<mat-dialog-content class="info-dialog-center">
  <mat-dialog-content>
    <sn-icon class="success-icon" *ngIf="icon" [icon]="icon"></sn-icon>
  </mat-dialog-content>
  <mat-dialog-title *ngIf="title">{{ title }}</mat-dialog-title>
  <mat-dialog-content>
    {{ message }}
  </mat-dialog-content>
  <mat-dialog-actions>
    <!-- [color] and [attr.color] both needed for buttons below for all SnColorPalette colors to work -->
    <button
      mat-button
      [color]="confirmButton.color"
      [attr.color]="confirmButton.color"
      (click)="confirm()"
    >
      {{ confirmButton.text }}
    </button>
    <button
      mat-button
      [color]="cancelButton.color"
      [attr.color]="cancelButton.color"
      (click)="cancel()"
    >
      {{ cancelButton.text }}
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
